import React, { ReactNode } from 'react';

import { locale } from '@trqk/utils';

import { getLocaleForCurrentPlan } from '../../utils';

interface CurrentPlanWrapperProps {
    children: ReactNode;
    planSettings: ChargebeePlanSettings | null;
    subscriptionSettings: ChargebeeSubscriptionSettings | null;
}

// This is a pixel-adjusted height that allows the title of the current plan to align vertically
// with the title of the future plans. It's a bit of a hack, but it means we don't have to worry
// about using a grid to lay out the current and future plans.
const currentPlanTopMargin = 25;

/**
 * Renders the title, subtitle and description for a current payment plan.
 * @param props - see {@link CurrentPlanWrapperProps}
 */
export const CurrentPlanWrapper = ({
    children,
    planSettings,
    subscriptionSettings,
}: CurrentPlanWrapperProps): JSX.Element => {
    const { title, subTitle } = getLocaleForCurrentPlan(
        planSettings,
        subscriptionSettings,
    );

    return (
        <div style={{ marginTop: currentPlanTopMargin }}>
            <h3 className="font-normal text-xl">{title.toUpperCase()}</h3>
            <div className="mb-6 text-sm">
                <span className="text-primary-500 font-semibold">
                    {locale.enUS.ACCOUNT.SECTIONS.PAYMENT_PLAN.CURRENT_PLAN}
                </span>
                {subTitle && (
                    <>
                        <span className="text-tertiary-300">{' | '}</span>
                        {subTitle}
                    </>
                )}
            </div>
            {children}
        </div>
    );
};
